(function () {
  'use strict';

  var PANEL_ID = 'soilife-cart-confirm';
  var CSS_ID = 'soilife-cart-confirm-css';
  var AUTO_CLOSE_MS = 8000;
  var closeTimer = null;

  function injectStyles() {
    if (document.getElementById(CSS_ID)) return;
    var css = [
      '#' + PANEL_ID + ' {',
      '  position: fixed;',
      '  top: 0;',
      '  right: -420px;',
      '  width: 400px;',
      '  max-width: 92vw;',
      '  height: 100vh;',
      '  background: #fff;',
      '  box-shadow: -4px 0 24px rgba(0,0,0,0.15);',
      '  z-index: 9999;',
      '  font-family: "Poppins", sans-serif;',
      '  transition: right 0.35s cubic-bezier(0.22, 1, 0.36, 1);',
      '  display: flex;',
      '  flex-direction: column;',
      '  overflow: hidden;',
      '}',
      '#' + PANEL_ID + '.is-open {',
      '  right: 0;',
      '}',
      '#' + PANEL_ID + ' .scc-overlay {',
      '  position: fixed;',
      '  inset: 0;',
      '  background: rgba(0,0,0,0.3);',
      '  z-index: -1;',
      '  opacity: 0;',
      '  transition: opacity 0.3s;',
      '  pointer-events: none;',
      '}',
      '#' + PANEL_ID + '.is-open .scc-overlay {',
      '  opacity: 1;',
      '  pointer-events: auto;',
      '}',
      '.scc-header {',
      '  display: flex;',
      '  align-items: center;',
      '  justify-content: space-between;',
      '  padding: 18px 20px;',
      '  border-bottom: 1px solid #eee;',
      '  flex-shrink: 0;',
      '}',
      '.scc-header-title {',
      '  font-size: 16px;',
      '  font-weight: 700;',
      '  color: #113B2B;',
      '  display: flex;',
      '  align-items: center;',
      '  gap: 8px;',
      '  margin: 0;',
      '}',
      '.scc-header-check {',
      '  width: 22px;',
      '  height: 22px;',
      '  background: #9ec658;',
      '  border-radius: 50%;',
      '  display: flex;',
      '  align-items: center;',
      '  justify-content: center;',
      '}',
      '.scc-header-check svg {',
      '  width: 14px;',
      '  height: 14px;',
      '  stroke: #fff;',
      '  fill: none;',
      '}',
      '.scc-close {',
      '  background: none;',
      '  border: none;',
      '  font-size: 22px;',
      '  color: #666;',
      '  cursor: pointer;',
      '  padding: 4px 8px;',
      '  line-height: 1;',
      '  border-radius: 4px;',
      '  transition: background 0.15s;',
      '}',
      '.scc-close:hover { background: #f5f5f5; color: #113B2B; }',
      '.scc-body {',
      '  flex: 1;',
      '  overflow-y: auto;',
      '  padding: 20px;',
      '}',
      '.scc-item {',
      '  position: relative;',
      '  display: flex;',
      '  gap: 16px;',
      '  padding-bottom: 20px;',
      '  border-bottom: 1px solid #f0f0f0;',
      '  margin-bottom: 20px;',
      '}',
      '.scc-item-img {',
      '  width: 90px;',
      '  height: 90px;',
      '  border-radius: 10px;',
      '  object-fit: cover;',
      '  background: #f7faf5;',
      '  flex-shrink: 0;',
      '}',
      '.scc-item-info { flex: 1; }',
      '.scc-item-title {',
      '  font-size: 15px;',
      '  font-weight: 600;',
      '  color: #113B2B;',
      '  margin: 0 0 4px;',
      '  line-height: 1.3;',
      '}',
      '.scc-item-variant {',
      '  font-size: 13px;',
      '  color: #6b7c72;',
      '  margin: 0 0 8px;',
      '}',
      '.scc-item-price {',
      '  font-size: 16px;',
      '  font-weight: 700;',
      '  color: #113B2B;',
      '}',
      '.scc-item-remove {',
      '  position: absolute; top: 0; right: 0;',
      '  width: 30px; height: 30px; padding: 0;',
      '  border: none; background: transparent; cursor: pointer;',
      '  color: #9aa896; border-radius: 50%;',
      '  display: flex; align-items: center; justify-content: center;',
      '}',
      '.scc-item-remove:hover { color: #e05555; background: #faf0f0; }',
      '.scc-item-qty {',
      '  display: inline-flex; align-items: center;',
      '  margin-top: 8px; border: 1px solid #E0E8DC; border-radius: 8px; overflow: hidden;',
      '}',
      '.scc-qty-btn {',
      '  width: 30px; height: 30px; padding: 0; border: none;',
      '  background: #fff; color: #113B2B; font-size: 17px; line-height: 1; cursor: pointer;',
      '}',
      '.scc-qty-btn:hover { background: #f0f5ec; }',
      '.scc-qty-btn:disabled { opacity: 0.5; cursor: default; }',
      '.scc-qty-num { min-width: 32px; text-align: center; font-size: 14px; font-weight: 600; color: #113B2B; }',
      '.scc-summary {',
      '  background: #f7faf5;',
      '  border-radius: 10px;',
      '  padding: 16px;',
      '}',
      '.scc-summary-row {',
      '  display: flex;',
      '  justify-content: space-between;',
      '  align-items: center;',
      '  font-size: 14px;',
      '  color: #4a5d52;',
      '  margin-bottom: 6px;',
      '}',
      '.scc-summary-row:last-child { margin-bottom: 0; }',
      '.scc-summary-total {',
      '  font-weight: 700;',
      '  font-size: 16px;',
      '  color: #113B2B;',
      '  border-top: 1px solid #e0e8dc;',
      '  padding-top: 10px;',
      '  margin-top: 10px;',
      '}',
      '.scc-footer {',
      '  padding: 16px 20px;',
      '  border-top: 1px solid #eee;',
      '  display: flex;',
      '  flex-direction: column;',
      '  gap: 10px;',
      '  flex-shrink: 0;',
      '}',
      '.scc-btn-checkout {',
      '  display: block;',
      '  width: 100%;',
      '  padding: 16px;',
      '  background: #113B2B;',
      '  color: #fff;',
      '  font-family: "Poppins", sans-serif;',
      '  font-size: 15px;',
      '  font-weight: 700;',
      '  text-align: center;',
      '  text-decoration: none;',
      '  text-transform: uppercase;',
      '  letter-spacing: 1px;',
      '  border: none;',
      '  border-radius: 8px;',
      '  cursor: pointer;',
      '  transition: background 0.2s, transform 0.15s;',
      '}',
      '.scc-btn-checkout:hover {',
      '  background: #9ec658;',
      '  color: #fff;',
      '  transform: translateY(-1px);',
      '}',
      '.scc-btn-continue {',
      '  display: block;',
      '  width: 100%;',
      '  padding: 12px;',
      '  background: none;',
      '  color: #113B2B;',
      '  font-family: "Poppins", sans-serif;',
      '  font-size: 14px;',
      '  font-weight: 600;',
      '  text-align: center;',
      '  border: 2px solid #e0e8dc;',
      '  border-radius: 8px;',
      '  cursor: pointer;',
      '  transition: border-color 0.2s, background 0.2s;',
      '}',
      '.scc-btn-continue:hover {',
      '  border-color: #113B2B;',
      '  background: #f7faf5;',
      '}',
      '.scc-upsell {',
      '  background: #f7faf5;',
      '  border: 1px solid #e0e8dc;',
      '  border-radius: 8px;',
      '  padding: 12px 14px;',
      '  font-size: 13px;',
      '  color: #113B2B;',
      '  font-weight: 600;',
      '  text-align: center;',
      '}',
      '.scc-upsell a {',
      '  color: #9ec658;',
      '  text-decoration: underline;',
      '  font-weight: 700;',
      '}',
      '@media (max-width: 480px) {',
      '  #' + PANEL_ID + ' { width: 100vw; max-width: 100vw; right: -100vw; }',
      '}'
    ].join('\n');

    var style = document.createElement('style');
    style.id = CSS_ID;
    style.textContent = css;
    document.head.appendChild(style);
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  // Best-effort update of the theme header cart count after a removal.
  function updateCartCount(n) {
    try {
      var els = document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"], .cart-count-bubble > span, [data-cart-count], .cart-count');
      for (var i = 0; i < els.length; i++) { els[i].textContent = n; }
      var bubble = document.querySelector('.cart-count-bubble');
      if (bubble) bubble.style.display = n ? '' : 'none';
    } catch (e) {}
  }

  function close() {
    var panel = document.getElementById(PANEL_ID);
    if (panel) panel.classList.remove('is-open');
    clearTimeout(closeTimer);
    document.removeEventListener('keydown', escHandler);
  }

  function escHandler(e) {
    if (e.key === 'Escape') close();
  }

  function open(addedItem) {
    injectStyles();

    // Fetch full cart for totals
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { render(addedItem, cart); })
      .catch(function () { render(addedItem, null); });
  }

  function render(item, cart) {
    // Remove existing
    var existing = document.getElementById(PANEL_ID);
    if (existing) existing.remove();

    var panel = document.createElement('div');
    panel.id = PANEL_ID;
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-label', 'Item added to cart');

    // Overlay
    var overlay = document.createElement('div');
    overlay.className = 'scc-overlay';
    overlay.addEventListener('click', close);
    panel.appendChild(overlay);

    // Header
    var header = document.createElement('div');
    header.className = 'scc-header';
    header.innerHTML =
      '<p class="scc-header-title">' +
        '<span class="scc-header-check"><svg viewBox="0 0 24 24" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg></span>' +
        'Added to cart' +
      '</p>';

    var closeBtn = document.createElement('button');
    closeBtn.className = 'scc-close';
    closeBtn.setAttribute('aria-label', 'Close cart panel');
    closeBtn.innerHTML = '&times;';
    closeBtn.addEventListener('click', close);
    header.appendChild(closeBtn);
    panel.appendChild(header);

    // Body
    var body = document.createElement('div');
    body.className = 'scc-body';

    // Show ALL cart items (not just the one added)
    var itemsToShow = cart ? cart.items : [item];
    itemsToShow.forEach(function (ci) {
      var itemEl = document.createElement('div');
      itemEl.className = 'scc-item';

      var imgSrc = ci.image || ci.featured_image || '';
      if (imgSrc) {
        var cleanSrc = imgSrc.indexOf('?') !== -1 ? imgSrc.split('?')[0] : imgSrc;
        if (cleanSrc.indexOf('cdn.shopify.com') !== -1) cleanSrc += '?width=200';
        var img = document.createElement('img');
        img.className = 'scc-item-img';
        img.src = cleanSrc;
        img.alt = ci.product_title || ci.title || '';
        img.loading = 'lazy';
        itemEl.appendChild(img);
      }

      var info = document.createElement('div');
      info.className = 'scc-item-info';
      info.innerHTML =
        '<p class="scc-item-title">' + (ci.product_title || ci.title || 'Product') + '</p>' +
        (ci.variant_title && ci.variant_title !== 'Default Title'
          ? '<p class="scc-item-variant">' + ci.variant_title + '</p>'
          : '') +
        '<span class="scc-item-price">' + formatMoney(ci.final_line_price || ci.price || 0) + '</span>';
      itemEl.appendChild(info);

      var qtyRow = document.createElement('div');
      qtyRow.className = 'scc-item-qty';
      var minusBtn = document.createElement('button');
      minusBtn.type = 'button'; minusBtn.className = 'scc-qty-btn';
      minusBtn.setAttribute('aria-label', 'Decrease quantity'); minusBtn.textContent = '-';
      var qtyNum = document.createElement('span');
      qtyNum.className = 'scc-qty-num'; qtyNum.textContent = ci.quantity;
      var plusBtn = document.createElement('button');
      plusBtn.type = 'button'; plusBtn.className = 'scc-qty-btn';
      plusBtn.setAttribute('aria-label', 'Increase quantity'); plusBtn.textContent = '+';
      function changeQty(newQty) {
        minusBtn.disabled = true; plusBtn.disabled = true;
        fetch('/cart/change.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: ci.key, quantity: newQty }), credentials: 'same-origin'
        })
        .then(function (r) { return r.json(); })
        .then(function (newCart) {
          updateCartCount(newCart.item_count);
          if (!newCart.item_count) { close(); } else { render(item, newCart); }
        })
        .catch(function () { minusBtn.disabled = false; plusBtn.disabled = false; });
      }
      minusBtn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); changeQty(Math.max(0, ci.quantity - 1)); });
      plusBtn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); changeQty(ci.quantity + 1); });
      qtyRow.appendChild(minusBtn); qtyRow.appendChild(qtyNum); qtyRow.appendChild(plusBtn);
      info.appendChild(qtyRow);

      var removeBtn = document.createElement('button');
      removeBtn.type = 'button';
      removeBtn.className = 'scc-item-remove';
      removeBtn.setAttribute('aria-label', 'Remove ' + (ci.product_title || ci.title || 'item'));
      removeBtn.innerHTML = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path></svg>';
      removeBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        removeBtn.disabled = true;
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: ci.key, quantity: 0 }),
          credentials: 'same-origin'
        })
        .then(function (r) { return r.json(); })
        .then(function (newCart) {
          updateCartCount(newCart.item_count);
          if (!newCart.item_count) { close(); }
          else { render(item, newCart); }
        })
        .catch(function () { removeBtn.disabled = false; });
      });
      itemEl.appendChild(removeBtn);

      body.appendChild(itemEl);
    });

    // Cart summary
    if (cart) {
      var summary = document.createElement('div');
      summary.className = 'scc-summary';

      summary.innerHTML =
        '<div class="scc-summary-row"><span>' + cart.item_count + ' item' + (cart.item_count !== 1 ? 's' : '') + ' in cart</span></div>' +
        '<div class="scc-summary-row scc-summary-total"><span>Subtotal</span><span>' + formatMoney(cart.total_price) + '</span></div>';

      body.appendChild(summary);

      // Bundle upsell nudge, matched to the quantity-based bundle discount
      // (2 items = 6% off, 3+ items = 12% off). Count the total quantity of the
      // three bundle products in the cart; hide the nudge once 12% is reached.
      var bundleHandles = ['soil-microbes-feeder', 'kelp-power', 'compost-microbes'];
      var bundleQty = 0;
      cart.items.forEach(function (ci) {
        if (bundleHandles.indexOf(ci.handle) !== -1) bundleQty += (ci.quantity || 0);
      });

      if (bundleQty >= 1 && bundleQty < 3) {
        var upsell = document.createElement('div');
        upsell.className = 'scc-upsell';
        upsell.style.marginTop = '16px';
        var bundleUrl = '/products/soilife-product-selector';
        if (bundleQty === 1) {
          upsell.innerHTML = 'Add 1 more for <strong>6% off</strong>. <a href="' + bundleUrl + '">Build your bundle</a>';
        } else {
          upsell.innerHTML = 'Add 1 more for <strong>12% off</strong>. <a href="' + bundleUrl + '">Complete your bundle</a>';
        }
        body.appendChild(upsell);
      }
    }

    panel.appendChild(body);

    // Footer
    var footer = document.createElement('div');
    footer.className = 'scc-footer';

    var checkoutBtn = document.createElement('a');
    checkoutBtn.href = '/checkout';
    checkoutBtn.className = 'scc-btn-checkout';
    checkoutBtn.textContent = 'Checkout';
    footer.appendChild(checkoutBtn);

    var viewCartBtn = document.createElement('a');
    viewCartBtn.href = '/cart';
    viewCartBtn.className = 'scc-btn-continue';
    viewCartBtn.textContent = 'View Cart';
    footer.appendChild(viewCartBtn);

    var continueBtn = document.createElement('button');
    continueBtn.type = 'button';
    continueBtn.className = 'scc-btn-continue';
    continueBtn.textContent = 'Continue Shopping';
    continueBtn.style.border = 'none';
    continueBtn.style.padding = '8px';
    continueBtn.style.fontSize = '13px';
    continueBtn.style.color = '#6b7c72';
    continueBtn.addEventListener('click', close);
    footer.appendChild(continueBtn);

    panel.appendChild(footer);
    document.body.appendChild(panel);

    // Animate open
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        panel.classList.add('is-open');
      });
    });

    // Auto-close
    clearTimeout(closeTimer);
    closeTimer = setTimeout(close, AUTO_CLOSE_MS);

    // Pause auto-close on hover/touch
    panel.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
    panel.addEventListener('mouseleave', function () { closeTimer = setTimeout(close, AUTO_CLOSE_MS); });
    panel.addEventListener('touchstart', function () { clearTimeout(closeTimer); }, { passive: true });
    panel.addEventListener('touchend', function () { closeTimer = setTimeout(close, AUTO_CLOSE_MS); }, { passive: true });

    // Escape key
    document.addEventListener('keydown', escHandler);

    // Focus the close button for a11y
    closeBtn.focus();
  }

  // ── Listen for cart adds via fetch interception (non-wrapping) ────
  // Instead of wrapping window.fetch (which conflicts with cart-upsell),
  // we use a single wrapper that dispatches a custom event.
  var _origFetch = window.fetch;
  window.fetch = function () {
    var args = arguments;
    var url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url ? args[0].url : '');
    var result = _origFetch.apply(this, args);

    if (url.indexOf('/cart/add') !== -1) {
      result.then(function (response) {
        return response.clone().json();
      }).then(function (data) {
        var addedItem = data;
        if (data.items && data.items.length > 0) addedItem = data.items[0];
        if (addedItem && (addedItem.title || addedItem.product_title)) {
          open(addedItem);
        }
        // Dispatch event so cart-upsell can listen without wrapping fetch again
        document.dispatchEvent(new CustomEvent('soilife:cart:added', { detail: data }));
      }).catch(function () {});
    }

    return result;
  };

  // Expose for manual trigger if needed
  window.soilifeCartConfirm = { open: open, close: close };
})();
